import { createContext, useContext, useState, useEffect, ReactNode } from 'react'

interface AuthState {
  email:     string | null
  isLoggedIn: boolean
  login:     (email: string) => void
  logout:    () => void
}

const AuthContext = createContext<AuthState>({
  email: null, isLoggedIn: false,
  login: () => {}, logout: () => {},
})

export function AuthProvider({ children }: { children: ReactNode }) {
  const [email, setEmail] = useState<string | null>(() =>
    sessionStorage.getItem('finkraft_user')
  )

  const login = (e: string) => {
    sessionStorage.setItem('finkraft_user', e)
    setEmail(e)
  }

  const logout = () => {
    sessionStorage.removeItem('finkraft_user')
    setEmail(null)
  }

  return (
    <AuthContext.Provider value={{ email, isLoggedIn: !!email, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
